import { render, staticRenderFns } from "./CasinoGameCard.vue?vue&type=template&id=35a34704&scoped=true"
import script from "./CasinoGameCard.vue?vue&type=script&lang=js"
export * from "./CasinoGameCard.vue?vue&type=script&lang=js"
import style0 from "./CasinoGameCard.vue?vue&type=style&index=0&id=35a34704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a34704",
  null
  
)

export default component.exports